import React from "react";
import { Container, Row, Col } from "reactstrap";
import HeadingText from "../common/HeadingText/HeadingText";

import "./FormSectionLayout.scss";

interface IFormSectionLayoutProps {
  subTitleText: string;
  isMainHeading?: boolean;
  image?: string;
  leftColumnChildren?: any;
}

const FormSectionLayout: React.FunctionComponent<IFormSectionLayoutProps> = (
  props
) => {
  return (
    <Container fluid className="form-section-container">
      <Row>
        <Col xs="4">
          <HeadingText
            text={props.subTitleText}
            isMainHeading={props.isMainHeading}
            image={props.image}
          />
          {props.leftColumnChildren}
        </Col>
        <Col xs="6" className="form-input-field-column">
          {props.children}
        </Col>
      </Row>
    </Container>
  );
};

FormSectionLayout.defaultProps = {
  isMainHeading: false,
  leftColumnChildren: () => {},
};

export default FormSectionLayout;
